import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemTraderMode extends Cloneable {

    static NONE = new ItemTraderMode(0, "NONE");

    static _values = [
        new ItemTraderMode(1, "EXCHANGER"),
        new ItemTraderMode(2, "SELLER"),
        new ItemTraderMode(3, "DEALER"),
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemTraderMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemTraderMode) {
            return ItemTraderMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemTraderMode.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemTraderMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemTraderMode());
        } else if (target instanceof ItemTraderMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemTraderMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});